import { UpdateAccountErrorKeys, UpdateAccountErrorListKeys, UpdateAccountHeaderErrorKeys } from "../../login/components/UpdateAccountSection";
import { useConversion } from "../hooks/use.analytics";
import { UpdateAccountResponse, UpdateAccoutError } from "../hooks/useUpdateAccountApi";
import { scrollIntoViewAndFocus } from "./scrollIntoViewAndFocus";
import { handle400Errors } from "./updateAccount400Errors";

interface Props {
    updateAccountResponse: UpdateAccountResponse
    errorContainerRef: React.MutableRefObject<HTMLDivElement | null>
    conversion: ReturnType<typeof useConversion> | null
    setApiErrorHeaderKey: React.Dispatch<React.SetStateAction<UpdateAccountHeaderErrorKeys | null>>
    setApiErrorKey: React.Dispatch<React.SetStateAction<UpdateAccountErrorKeys | null>>
    setAnalyticsKey: React.Dispatch<React.SetStateAction<UpdateAccountErrorKeys | UpdateAccountErrorListKeys | "unknownError" | undefined>>
    setApiErrorListKey: React.Dispatch<React.SetStateAction<UpdateAccountErrorListKeys | null>>
    setAlreadyUsed: React.Dispatch<React.SetStateAction<boolean>>
    // newPasswordErrorSetter: (newValue: boolean) => boolean
    // confirmNewPasswordErrorSetter: (newValue: boolean) => boolean
    count: number
    showPageCallback: () => void
}

export const handleUpdateAccountResponseCodes = (props: Props) => {
    const { 
        updateAccountResponse, 
        errorContainerRef, 
        conversion, 
        showPageCallback, 
        setApiErrorHeaderKey, 
        setApiErrorKey, 
        setAnalyticsKey, 
        setApiErrorListKey,
        setAlreadyUsed,
        // newPasswordErrorSetter,
        // confirmNewPasswordErrorSetter,
        count,
    } = props;
    const errorArgs = {
        updateAccountResponse: updateAccountResponse as {
            code: number;
            errors: UpdateAccoutError[];
        },
        setApiErrorHeaderKey,
        setApiErrorKey,
        setAnalyticsKey,
        setApiErrorListKey,
        setAlreadyUsed,
        // newPasswordErrorSetter,
        // confirmNewPasswordErrorSetter
    }

    if(updateAccountResponse?.code !== 204){
        scrollIntoViewAndFocus(errorContainerRef.current);
    }
    switch (updateAccountResponse?.code) {
        case 204:
            conversion && conversion.success();
            showPageCallback();
            break;
        case 400:
            handle400Errors(errorArgs);
            break;
        case 401:
            if (count <= 3) {
                setApiErrorHeaderKey('doesntMatch');
                setApiErrorKey('tryAgain');
                setAnalyticsKey('tryAgain');
            }
            else if (count === 4) {
                setApiErrorHeaderKey('doesntMatch');
                setApiErrorKey('oneMoreTry');
                setAnalyticsKey('oneMoreTry');
            }
            else {
                setApiErrorHeaderKey('locked');
                setApiErrorKey('tryToLog');
                setAnalyticsKey('tryToLog');
            }
            break;
        case 403:
            setApiErrorHeaderKey('locked');
            setApiErrorKey('tryToLog');
            setAnalyticsKey('tryToLog');
            break;
        case 409:
            setApiErrorHeaderKey('completeItems');
            setApiErrorListKey('alreadyUsed');
            setAnalyticsKey('alreadyUsed');
            break;
        case 404:
        default:
            setApiErrorHeaderKey('cantProcess');
            setApiErrorKey('inconvenience');
            setAnalyticsKey('inconvenience');
            break;
    }
}